import React from 'react';
import { PostHogProvider } from 'posthog-js/react';

type Props = {
  children: React.ReactNode;
};

const isProd = process.env.REACT_APP_BUILD_ENV === 'production';

const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
};

export const PostHogWrapper = ({ children }: Props) => {
  if (!isProd) return <>{children}</>;

  return (
    <PostHogProvider
      apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY!}
      options={options}>
      {children}
    </PostHogProvider>
  );
};
